export type JobVersion = 1 | 2

export const judgeJobVersion = (jobCode: string): JobVersion => {
  return jobCode.startsWith('JN') ? 2 : 1
}

export const jobPreviewPath = (jobCode: string): string => {
  const version = judgeJobVersion(jobCode)
  switch (version) {
    case 1:
      return `/jobs/${jobCode}`
    case 2:
      return `/jobs/${jobCode}/preview?publish=1`
    default:
      return ''
  }
}

export const jobFeatureToTags = (
  job: GetMessages200ResponseJobsInner | GetJobV2200ResponseJob | undefined,
  desiredConditionOptions: {
    [key: string]:
      | {
          options:
            | { label: string | undefined; id: number | undefined }[]
            | undefined
        }
      | undefined
  },
) => {
  const mapItems = (
    items: number[],
    optionsPath: { label: string | undefined; id: number | undefined }[],
  ) => {
    return items.map((item) => {
      const option = optionsPath.find((option) => option.id === item)
      return option?.label ? option.label : ''
    })
  }

  if (!job) return []
  const organizationFeatures = mapItems(
    job.organizationFeatures || [],
    desiredConditionOptions.organization?.options || [],
  )
  const businessFeatures = mapItems(
    job.businessFeatures || [],
    desiredConditionOptions.business?.options || [],
  )
  const workEnvironmentFeatures = mapItems(
    job.workEnvironmentFeatures || [],
    desiredConditionOptions.environment?.options || [],
  )
  return [
    ...organizationFeatures,
    ...businessFeatures,
    ...workEnvironmentFeatures,
  ]
}

export const mapJobV2JobLocationType = (
  jobLocationType: string | undefined,
): JobV2LocationType | 0 => {
  switch (jobLocationType) {
    case jobLocationTypes.OFFICE:
      return jobV2LocationTypes.OFFICE
    case jobLocationTypes.OFFICE_AND_REMOTE:
      return jobV2LocationTypes.OFFICE_AND_REMOTE
    case jobLocationTypes.FULL_REMOTE:
      return jobV2LocationTypes.FULL_REMOTE
    default:
      return 0
  }
}

export const mapJobV1ToJobV2 = (
  jobV1: GetJobDetails200Response,
  jobV2: GetJobV2200ResponseJob,
): GetJobV2200ResponseJob => ({
  ...jobV2,
  coverImagePath: jobV1.coverImagePath || '',
  employment:
    // 単一選択の場合は設定、それ以外は0
    jobV1.employments && jobV1.employments.length === 1
      ? jobV1.employments?.[0]?.employmentId
      : 0,
  teamGoals: jobV1.departmentMission || '',
  designApproach: jobV1.companyThinking || '',
  designersCount: jobV1.designerEmployees || '',
  evaluationMethod: jobV1.evaluation || '',
  careerPath: jobV1.careerPath || '',
  designerVoices: jobV1.designerImpressions || '',
  jobLocationType: mapJobV2JobLocationType(jobV1.jobLocationType),
  jobLocations:
    jobV1.jobLocations?.map((location) => ({
      postalCode: location.postalCode || '',
      prefecture: location.prefecture || 0,
      addressCity: location.addressCity || '',
      addressLocal: location.addressLocal || '',
      passiveSmokingPrevention: 0, // jobV1には存在しないため未選択値
    })) || [],
  workingHours: jobV1.workingHours || '',
  benefits: jobV1.benefits || '',
  holiday: jobV1.holiday || '',
  hiringStep: jobV1.hiringStep || '',
  relatedLinks:
    jobV1.relatedLinks?.map((link) => ({
      title: link.title,
      url: link.linkUrl,
      imagePath: link.imageUrl,
      text: link.text,
    })) || [],
  services: jobV1.services || '',
  isWebPublished: jobV1.isWebPublished,
  trialPeriod: jobV1.trialPeriod || '',
})
